import { apiPost } from "../client";
import { useMutation } from "@tanstack/react-query";
import type { IExamProgress } from "./types";
import type { IApiResponse } from "../client";

export async function apiSubmitModule(
  progressId: string,
  examPaperId: string
): Promise<IApiResponse<IExamProgress>> {
  return apiPost(
    `/exam_progress/${progressId}/exam_papers/${examPaperId}/submit`
  );
}

export function useMutationSubmitModule() {
  return useMutation({
    mutationFn: ({
      progressId,
      examPaperId,
    }: {
      progressId: string;
      examPaperId: string;
    }) => apiSubmitModule(progressId, examPaperId),
  });
}
